import { useState } from 'react'
import {
  Datagrid,
  DateField,
  DateInput,
  Edit,
  Filter,
  Form,
  FormDataConsumer,
  List,
  NumberField,
  NumberInput,
  ReferenceManyField,
  SaveButton,
  SearchInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  TextField,
  TextInput,
  useNotify,
  useRecordContext,
  useTranslate,
} from 'react-admin'
import { ExtraPagination } from './utils'
import {
  Box,
  CardHeader,
  Grid,
  List as ListMui,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import GetAppIcon from '@mui/icons-material/GetApp'
import UpsertFileButton, { PreviewButton } from './components/file_upload'
import FileWithContext from './models/file_with_context'
import { RichTextInput } from 'ra-input-rich-text'
import { makeStyles } from '@material-ui/core/styles'
import CollapseMoreIcon from '@mui/icons-material/ExpandMore'
import CollapseExpandLessIcon from '@mui/icons-material/ExpandLess'
import Logo from './assets/images/Logo.png'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ToggleArchiveStatusButton from './intranet/Copros/components/ToggleArchiveStatusButton'
const CoproFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
)
export const CoproFicheList = (props) => (
  <List
    {...props}
    exporter={false}
    pagination={<ExtraPagination />}
    filters={<CoproFilter />}
    title="Fiches Immeuble"
    perPage={100}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <NumberField source="id" label="Id" />
      <TextField source="copromatic_id" label="Id copromatic" />
      <TextField source="libelle" label="libelle" />
      <TextField source="code" label="Code" />
      <TextField source="fiche_adresse" label="Adresse" />
    </Datagrid>
  </List>
)

export const DenominationForm = ({ copro, refresh }) => {
  const variant = 'outlined'

  return (
    <Form>
      <Box p=".7em">
        <Box display="flex">
          <Box flex={2} mr="1em">
            <Typography variant="h6" style={{ padding: '0.5rem' }}>
              <b>Dénomination</b>
            </Typography>
            <Box display="flex">
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  source="fiche_adresse"
                  label="Adresse"
                  variant={variant}
                  size="small"
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  size="small"
                  source="fiche_code"
                  label="Code copropriété"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  size="small"
                  source="fiche_email_contact"
                  label="Email de contact du conseil syndical"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <SelectInput
                  size="small"
                  margin="none"
                  fullWidth={true}
                  source="fiche_contact_preference"
                  label="Préférence de contact du conseil syndical"
                  choices={[
                    { id: '1', name: 'Membres individuels du CS' },
                    { id: '2', name: 'Email contact CS' },
                    { id: '3', name: 'Les 2' },
                  ]}
                  variant={variant}
                />
              </Box>
            </Box>
            {/* <Box display="flex">
              <Box flex={1} mr="0.5em" ml="0.5em">
                <NumberInput
                  source="id"
                  label="Copromatic Id"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <NumberInput
                  source="count_coproprietaires"
                  label="Nb copropriétaires"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em"></Box>
              <Box flex={1} mr="0.5em" ml="0.5em"></Box>
            </Box> */}
          </Box>
        </Box>
      </Box>
      <Toolbar>
        <Box display="flex" justifyContent="flex-start" width="100%">
          <SaveButton style={{ marginRight: '10px' }} />
          <ToggleArchiveStatusButton record={copro} refresh={refresh} />
        </Box>
      </Toolbar>
    </Form>
  )
}

export const ParticularitiesForm = ({ title, sourceName }) => {
  return (
    <Form>
      <Box p=".7em">
        <Box display="flex">
          <Box flex={2} mr="1em">
            <Typography variant="h6" style={{ padding: '0.5rem' }}>
              <b>{title}</b>
            </Typography>
            <Box display="flex" mt="1em">
              <Box flex={1} mr="0.5em" ml="0.5em">
                <RichTextInput source={sourceName} label={false} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Toolbar>
        <Box display="flex" justifyContent="space-between" width="100%">
          <SaveButton />
        </Box>
      </Toolbar>
    </Form>
  )
}

export const AccesForm = (props) => {
  const variant = 'outlined'
  return (
    <Form>
      <Box p=".7em">
        <Box display="flex">
          <Box flex={2} mr="1em">
            <Typography variant="h6" style={{ padding: '0.5rem' }}>
              <b>Accès</b>
            </Typography>
            <Box display="flex">
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  source="fiche_complement_adresse"
                  label="Fiche comp. adresse"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <NumberInput
                  source="fiche_nb_lots_principaux"
                  label="Nb lots principaux"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <NumberInput
                  source="fiche_nb_lots_annexes"
                  label="Nb lots annexes"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <NumberInput
                  source="fiche_nb_batiments"
                  label="Nb bâtiments"
                  variant={variant}
                />
              </Box>
            </Box>
            <Box display="flex">
              <Box flex={1} mr="0.5em" ml="0.5em">
                <NumberInput
                  source="fiche_nb_etages"
                  label="Nb étages"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  source="fiche_codes_acces"
                  label="Codes d'accès"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  source="fiche_vigik"
                  label="Vigik"
                  variant={variant}
                />
              </Box>
              <Box flex={1} mr="0.5em" ml="0.5em">
                <TextInput
                  source="fiche_interphones"
                  label="Interphones"
                  variant={variant}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Toolbar>
        <Box display="flex" justifyContent="space-between" width="100%">
          <SaveButton />
        </Box>
      </Toolbar>
    </Form>
  )
}

const EquipementForm = (props) => (
  <Form>
    <Box p=".7em">
      <Box display="flex">
        <Box flex={2} mr="1em">
          <Typography variant="h6" style={{ padding: '0.5rem' }}>
            <b>Equipements</b>
          </Typography>
          <Box display="flex">
            <Box flex={1} mr="0.5em" ml="0.5em">
              <NumberInput source="fiche_nb_ascenseurs" label="Nb ascenseurs" />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_chauffage"
                label="Chauffage"
                choices={[
                  { id: 'privatif', name: 'privatif' },
                  { id: 'collectif gaz', name: 'collectif gaz' },
                  { id: 'collectif fioul', name: 'collectif fioul' },
                  {
                    id: 'collectif électrique',
                    name: 'collectif électrique',
                  },
                  {
                    id: 'collectif géothermie / chauffage urbain',
                    name: 'collectif géothermie / chauffage urbain',
                  },
                  {
                    id: 'collectif mer',
                    name: 'collectif mer',
                  },
                ]}
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_petit_jardin"
                label="Petit jardin?"
                choices={[
                  { id: 'Oui', name: 'Oui' },
                  { id: 'Non', name: 'Non' },
                ]}
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_jardin_avec_entretien"
                label="Jardin avec entretien?"
                choices={[
                  { id: 'Oui', name: 'Oui' },
                  { id: 'Non', name: 'Non' },
                ]}
              />
            </Box>
          </Box>
          <Box display="flex">
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_parking"
                label="Parking?"
                choices={[
                  { id: 'Oui', name: 'Oui' },
                  { id: 'Non', name: 'Non' },
                ]}
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_compteur_eau_froide"
                label="Compteur eau froide"
                choices={[
                  { id: 'non', name: 'non' },
                  { id: 'copropriété', name: 'copropriété' },
                  { id: 'société', name: 'société' },
                ]}
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_compteur_eau_chaude"
                label="Compteur eau chaude"
                choices={[
                  { id: 'non', name: 'non' },
                  { id: 'copropriété', name: 'copropriété' },
                  { id: 'société', name: 'société' },
                ]}
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <SelectInput
                source="fiche_compteur_thermique"
                label="Compteur thermique"
                choices={[
                  { id: 'non', name: 'non' },
                  { id: 'copropriété', name: 'copropriété' },
                  { id: 'société', name: 'société' },
                ]}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        <SaveButton />
      </Box>
    </Toolbar>
  </Form>
)

const ComptaForm = (props) => (
  <Form>
    <Box p=".7em">
      <Box display="flex">
        <Box flex={2} mr="1em">
          <Typography variant="h6" style={{ padding: '0.5rem' }}>
            <b>Informations comptables clés</b>
          </Typography>
          <Box display="flex">
            <Box flex={1} mr="0.5em" ml="0.5em">
              <DateInput
                source="fiche_date_cloture_comptable"
                label="Date de clôture comptable"
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <DateInput source="fiche_date_ag_n1" label="Date AG N-1" />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <DateInput source="fiche_date_ag_n2" label="Date AG N-2" />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <DateInput source="fiche_date_ag_n3" label="Date AG N-3" />
            </Box>
          </Box>
          <Box display="flex">
            <Box flex={1} mr="0.5em" ml="0.5em">
              <TextInput
                source="fiche_rib_compte_courant"
                label="RIB compte courant"
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <TextInput
                source="fiche_rib_compte_travaux"
                label="RIB compte travaux"
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em">
              <TextInput
                source="fiche_numero_ics"
                label="Numéro ICS de la copro"
              />
            </Box>
            <Box flex={1} mr="0.5em" ml="0.5em"></Box>
          </Box>
        </Box>
      </Box>
    </Box>
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        <SaveButton />
      </Box>
    </Toolbar>
  </Form>
)

const DiagAmianteForm = (props) => {
  const notify = useNotify()
  const translate = useTranslate()

  return (
    <Form>
      <Box p=".7em">
        <Box display="flex">
          <Box flex={2} mr="1em">
            <Typography variant="h6" style={{ padding: '0.5rem' }}>
              <b>Diagnostic Amiante</b>
            </Typography>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                return (
                  <>
                    <SelectInput
                      source="fiche_diagnostic_amiante"
                      label="Diagnostic amiante applicable?"
                      choices={[
                        { id: 'Oui', name: 'Oui' },
                        { id: 'Non', name: 'Non' },
                      ]}
                    />

                    {formData.fiche_diagnostic_amiante === 'Oui' && (
                      <SelectInput
                        style={{ marginLeft: '0.5em' }}
                        source="fiche_diagnostic_amiante_renouvellement"
                        label="Renouvellement à prévoir?"
                        choices={[
                          { id: 'Oui', name: 'Oui' },
                          { id: 'Non', name: 'Non' },
                        ]}
                      />
                    )}
                  </>
                )
              }}
            </FormDataConsumer>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (formData.fiche_diagnostic_amiante !== 'Oui') {
                  return null
                }
                return (
                  <div style={{ marginLeft: '-7px' }}>
                    <Box display="flex">
                      <Box flex={1} mr="0.5em" ml="0.5em">
                        <UpsertFileButton
                          defaultValue={formData.asbestos_documents}
                          linkable_type="copros"
                          linkable_id={formData.id}
                          copro_id={formData.id}
                          resource="file_with_context"
                          basePath="file_with_context"
                          documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
                          issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                          validCategories={[FileWithContext.CATEGORY.BUILDING]}
                          validTypes={[FileWithContext.TYPE.ASBESTOS_DIAGNOSIS]}
                          saveResult={(result) => {
                            if (
                              result.rejected_files.length === 0 &&
                              result.accepted_files > 0
                            ) {
                              notify(translate('hs.file.success.upload_file'))
                            }
                          }}
                          show_shared_select={true}
                        />
                      </Box>
                    </Box>
                  </div>
                )
              }}
            </FormDataConsumer>
          </Box>
        </Box>
      </Box>
      <Toolbar>
        <Box display="flex" justifyContent="space-between" width="100%">
          <SaveButton />
        </Box>
      </Toolbar>
    </Form>
  )
}

const DiagPlombForm = (props) => {
  const notify = useNotify()
  const translate = useTranslate()

  return (
    <Form>
      <Box p=".7em">
        <Box display="flex">
          <Box flex={2} mr="1em">
            <Typography variant="h6" style={{ padding: '0.5rem' }}>
              <b>Diagnostic Plomb</b>
            </Typography>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                return (
                  <div>
                    <Box display="flex">
                      <SelectInput
                        source="fiche_diagnostic_plomb"
                        label="Diagnostic plomb applicable?"
                        choices={[
                          { id: 'Oui', name: 'Oui' },
                          { id: 'Non', name: 'Non' },
                        ]}
                      />
                      {formData.fiche_diagnostic_plomb === 'Oui' && (
                        <SelectInput
                          style={{ marginLeft: '0.5em' }}
                          source="fiche_diagnostic_plomb_renouvellement"
                          label="Renouvellement à prévoir?"
                          choices={[
                            { id: 'Oui', name: 'Oui' },
                            { id: 'Non', name: 'Non' },
                          ]}
                        />
                      )}
                    </Box>
                  </div>
                )
              }}
            </FormDataConsumer>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (formData.fiche_diagnostic_plomb !== 'Oui') {
                  return null
                }
                return (
                  <div style={{ marginLeft: '-7px' }}>
                    <Box display="flex">
                      <Box flex={1} mr="0.5em" ml="0.5em">
                        <UpsertFileButton
                          defaultValue={formData.lead_documents}
                          linkable_type="copros"
                          linkable_id={formData.id}
                          copro_id={formData.id}
                          resource="file_with_context"
                          basePath="file_with_context"
                          documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
                          issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                          validCategories={[FileWithContext.CATEGORY.BUILDING]}
                          validTypes={[FileWithContext.TYPE.LEAD_DIAGNOSIS]}
                          saveResult={(result) => {
                            if (
                              result.rejected_files.length === 0 &&
                              result.accepted_files > 0
                            ) {
                              notify(translate('hs.file.success.upload_file'))
                            }
                          }}
                          show_shared_select={true}
                        />
                      </Box>
                    </Box>
                  </div>
                )
              }}
            </FormDataConsumer>
          </Box>
        </Box>
      </Box>
      <Toolbar>
        <Box display="flex" justifyContent="space-between" width="100%">
          <SaveButton />
        </Box>
      </Toolbar>
    </Form>
  )
}

const DiagTermitesForm = (props) => {
  const notify = useNotify()
  const translate = useTranslate()

  return (
    <Form
      {...props}
      render={(formProps) => (
        // here starts the custom form layout
        <form>
          <Box p=".7em">
            <Box display="flex">
              <Box flex={2} mr="1em">
                <Typography variant="h6" style={{ padding: '0.5rem' }}>
                  <b>Diagnostic Termites</b>
                </Typography>
                <FormDataConsumer>
                  {({ formData, ...rest }) => {
                    return (
                      <div>
                        <Box display="flex">
                          <SelectInput
                            source="fiche_diagnostic_termites"
                            label="Diagnostic termites applicable?"
                            choices={[
                              { id: 'Oui', name: 'Oui' },
                              { id: 'Non', name: 'Non' },
                            ]}
                          />
                          {formData.fiche_diagnostic_termites === 'Oui' && (
                            <SelectInput
                              style={{ marginLeft: '0.5em' }}
                              source="fiche_diagnostic_termites_renouvellement"
                              label="Renouvellement à prévoir?"
                              choices={[
                                { id: 'Oui', name: 'Oui' },
                                { id: 'Non', name: 'Non' },
                              ]}
                            />
                          )}
                        </Box>
                      </div>
                    )
                  }}
                </FormDataConsumer>
                <FormDataConsumer>
                  {({ formData, ...rest }) => {
                    if (formData.fiche_diagnostic_termites !== 'Oui') {
                      return null
                    }
                    return (
                      <div style={{ marginLeft: '-7px' }}>
                        <Box display="flex">
                          <Box flex={1} mr="0.5em" ml="0.5em">
                            <UpsertFileButton
                              defaultValue={formData.termites_documents}
                              linkable_type="copros"
                              linkable_id={formData.id}
                              copro_id={formData.id}
                              resource="file_with_context"
                              basePath="file_with_context"
                              documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
                              issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                              validCategories={[
                                FileWithContext.CATEGORY.BUILDING,
                              ]}
                              validTypes={[
                                FileWithContext.TYPE.TERMITE_DIAGNOSIS,
                              ]}
                              saveResult={(result) => {
                                if (
                                  result.rejected_files.length === 0 &&
                                  result.accepted_files > 0
                                ) {
                                  notify(
                                    translate('hs.file.success.upload_file')
                                  )
                                }
                              }}
                              show_shared_select={true}
                            />
                          </Box>
                        </Box>
                      </div>
                    )
                  }}
                </FormDataConsumer>
              </Box>
            </Box>
          </Box>
          <Toolbar>
            <Box display="flex" justifyContent="space-between" width="100%">
              <SaveButton
                disabled={formProps.pristine}
                saving={formProps.saving}
                handleSubmit={formProps.handleSubmit}
              />
            </Box>
          </Toolbar>
        </form>
      )}
    />
  )
}

const DocumentsForm = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const translate = useTranslate()
  if (!record) return null

  return (
    <Box p="1em 1.6em">
      <Typography variant="h6" style={{ padding: '0.5rem' }}>
        <b>{translate('resources.file_with_context.name')}</b>
      </Typography>
      <UpsertFileButton
        defaultValue={record.copro_documents}
        linkable_type="copros"
        linkable_id={record.id}
        copro_id={record.id}
        resource="file_with_context"
        basePath="file_with_context"
        documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        validTypes={[
          FileWithContext.TYPE.DESCRIPTIVE_STATEMENT_DIVISION,
          FileWithContext.TYPE.COOWNERSHIP_MODIFICATIONS,
          FileWithContext.TYPE.COOWNERSHIP_RULES,
          FileWithContext.TYPE.PV,
          FileWithContext.TYPE.PV_SIGNED,
        ]}
        saveResult={(result) => {
          if (result.rejected_files.length === 0 && result.accepted_files > 0) {
            notify(translate('hs.file.success.upload_file'))
          }
        }}
        show_shared_select={true}
      />
    </Box>
  )
}

const OtherDocumentsForm = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const translate = useTranslate()
  if (!record) return null

  return (
    <Box p="1em 1.6em">
      <Typography variant="h6" style={{ padding: '0.5rem' }}>
        <b>{translate('resources.file_with_context.title')}</b>
      </Typography>
      <UpsertFileButton
        defaultValue={record.other_documents}
        showCoproSelection={true}
        copro_id={record.id}
        linkable_type="copros"
        linkable_id={record.id}
        resource="file_with_context"
        basePath="file_with_context"
        documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        validTypes={[
          FileWithContext.TYPE.QUOTE,
          FileWithContext.TYPE.INVOICE,
          FileWithContext.TYPE.INSURANCE_CERTIFICATE,
          FileWithContext.TYPE.INTERVENTION_REPORT,
          FileWithContext.TYPE.ANALYSIS_OR_EXPERT_REPORT,
        ]}
        saveResult={(result) => {
          if (result.rejected_files.length === 0 && result.accepted_files > 0) {
            notify(translate('hs.file.success.upload_file'))
          }
        }}
        show_shared_select={true}
      />
    </Box>
  )
}

export const CoproFicheEdit = (props) => {
  const commonProps = {
    ...props,
    redirect: false,
  }
  return (
    <>
      <Edit {...commonProps} title="Fiche Immeuble">
        <DenominationForm {...commonProps} />
      </Edit>
      <Edit {...commonProps} title=" " actions={false}>
        <ParticularitiesForm
          title={'Particularités de la copropriété'}
          sourceName={'specifications_of_coownership'}
        />
      </Edit>
      <Edit {...commonProps} title=" " actions={false}>
        <ParticularitiesForm
          title={'Particularités comptable'}
          sourceName={'specifications_of_accountant'}
        />
      </Edit>
      <Edit {...commonProps} title=" ">
        <AccesForm {...commonProps} />
      </Edit>
      <Edit {...commonProps} title=" ">
        <EquipementForm {...commonProps} />
      </Edit>
      <Edit {...commonProps} title=" ">
        <ComptaForm {...commonProps} />
      </Edit>
      <Edit {...commonProps} title=" ">
        <DiagAmianteForm {...commonProps} />
      </Edit>
      <Edit {...commonProps} title=" ">
        <DiagPlombForm {...commonProps} />
      </Edit>
      <Edit {...commonProps} title=" ">
        <DiagTermitesForm {...commonProps} />
      </Edit>

      <Show
        {...props}
        title=" "
        actions={false}
        style={{ marginBottom: '1rem' }}
      >
        <SimpleShowLayout style={{ padding: '1rem' }}>
          <Typography variant="h6" style={{ padding: '0.5rem' }}>
            <b>Contrats</b>
          </Typography>
          <ReferenceManyField
            label=" "
            reference="contracts"
            target="copro_id_nomonday"
          >
            <Datagrid bulkActionButtons={false} rowClick="show">
              <TextField source="id" />
              <TextField source="type" label="Type" />
              <TextField source="subtype" label="Sous-type" />
              <DateField label="Fin" source="end_date" />
              <DateField label="Créé le" source="created" />
            </Datagrid>
          </ReferenceManyField>
        </SimpleShowLayout>
      </Show>
    </>
  )
}
